import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class IllegalArgumentException extends Exception {
}
IllegalArgumentException.kind = 'IllegalArgumentException';
export default IllegalArgumentException;
